import {
  botPersonalizerImg1,
  botPersonalizerImg2,
  botPersonalizerImg3,
  botPersonalizerImg4,
} from "../../assets/images/index.js";

export const botPersonalizerData = [
  {
    title: "Build Your Own Discord Bot",
    paragraph:
      "Customize your bot by changing its avatar, name, and activity while leveraging the power of MEE6 plugins.",
    showDiscordButton: true,
    image: botPersonalizerImg1,
    imagePosition: "right",
  },
  {
    title: "Match your server's personality and aesthetic",
    paragraph:
      "Customise your bot's name, backstory, avatar, and status. Cohesive and branded look on your server is one of the cornerstones of a strong community. Create a more professional appearance that matches your server's purpose and helps build trust within your community.",
    showDiscordButton: true,
    image: botPersonalizerImg3,
    imagePosition: "right",
  },
  {
    title: "AI-powered backstories",
    paragraph:
      "Our AI engine can generate deep backstory for your bot. Fancy a Rick Sanchez talking to you in rhymes or Harry Potter spilling magic secrets? Anything is possible.",
    showDiscordButton: true,
    image: botPersonalizerImg4,
    imagePosition: "left",
  },
  {
    title: "Setup your own bot in less than 3 minutes",
    paragraph:
      "No need to learn how to code. You can setup your own bot and enjoy the power of MEE6’s plugins! We host the bot for you 24/7 at no extra cost!",
    showDiscordButton: true,
    image: botPersonalizerImg2,
    imagePosition: "right",
  },
];
